export default __webpack_public_path__ + "static/media/collapse_new.6ec09a21.svg";